var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7812 6.09375C16.9062 5.75 17 5.40625 17 5C17 3.34375 15.6562 2 14 2C13.375 2 12.7812 2.1875 12.3125 2.53125C11.4688 1.03125 9.84375 0 8 0C5.21875 0 3 2.25 3 5C3 5.09375 3 5.1875 3 5.28125C1.25 5.875 0 7.5625 0 9.5C0 12 2 14 4.5 14H16C18.1875 14 20 12.2188 20 10C20 8.09375 18.625 6.46875 16.7812 6.09375ZM13.25 9.03125L10.5 11.7812C10.4375 11.875 10.25 12 10 12C9.71875 12 9.53125 11.875 9.46875 11.7812L6.71875 9.03125C6.40625 8.75 6.40625 8.28125 6.71875 8C7 7.6875 7.46875 7.6875 7.75 8L9.25 9.46875V4.75C9.25 4.34375 9.5625 4 10 4C10.4062 4 10.75 4.34375 10.75 4.75V9.46875L12.2188 8C12.5 7.6875 12.9688 7.6875 13.25 8C13.5625 8.28125 13.5625 8.75 13.25 9.03125Z",
    fill: "#9AAAC7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download-icon.0c13ef257954454d5d8c96d06f0f41e9.svg";